<template>
  <v-layout wrap style="background-color: #08130b">
    <v-flex>
      <v-layout wrap>
        <v-flex justify-center xs12>
          <v-layout wrap pa-8 pa-sm-16>
            <v-flex
              pb-2
              xs12
              text-left
              style="font: 30px ibmsemibold; color: #ffffff"
            >
              KL 06
            </v-flex>
            <v-flex xs12 pb-lg-7 style="font-family: sofialight">
              <v-layout wrap>
                <v-flex text-left md1 v-for="(item,i) in navItems" :key="i" style="color: #ffffff"> 
                  <router-link style="color:#FFFFFF" :to="item.route">
                    
                  {{ item.name }}
                  </router-link>
                </v-flex>
                <!-- <v-flex md1 text-left style="color: #ffffff"> Plants </v-flex>
                <v-flex md1 text-left style="color: #ffffff"> Fertilizers </v-flex>
                <v-flex md1 text-left style="color: #ffffff"> Travel & Tourism </v-flex> -->
                <v-flex>
                  <v-spacer></v-spacer>
                </v-flex>
                <v-flex
                  xs12
                  sm3
                  py-4
                  py-sm-0
                  md2
                  text-right
                  style="color: white"
                >
                  <v-layout wrap>
                    <v-flex>
                      <v-img
                        width="20px"
                        height="20px"
                        contain
                        src="../../assets/Images/twitter.svg"
                      ></v-img>
                    </v-flex>
                    <v-flex>
                      <v-img
                        width="20px"
                        height="20px"
                        contain
                        src="../../assets/Images/facebook.svg"
                      ></v-img>
                    </v-flex>
                    <v-flex>
                      <v-img
                        width="20px"
                        height="20px"
                        contain
                        src="../../assets/Images/linkdin.svg"
                      ></v-img>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              py-sm-3
              xs12
              md6
              lg5
              justify-center
              text-justify
              style="font-family: sofialight; color: #777777"
            >
              <span>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex py-2 py-sm-0 align-self-end text-right>
              <span style="margin-right: 10px"
                ><v-icon color="#B2B2B2">mdi-email</v-icon></span
              >
              <span style="color: #777777"> kl06@gmail.com</span>
            </v-flex>
            <v-flex py-2 py-sm-0 align-self-end text-right>
              <span
                ><v-icon style="margin-right: 10px" color="#B2B2B2"
                  >mdi-phone</v-icon
                ></span
              >
              <span style="color: #777777"> +9184773687434</span>
            </v-flex>
          </v-layout>
        </v-flex>
        
      </v-layout>

      <v-layout
        style="color: #adadad; font-family: sofialight"
        wrap
        text-center
        py-lg-3
      >
        <v-flex py-3> LEOPARD TECH LABS PVT.LTD </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      
      navItems: [
        // { name: "New Arrivals", route: "/New Arrivals", type: "link" },
        { name: "Plants", route: "/Plants", type: "link" },
        { name: "Spices", route: "/Spices", type: "link" },
        { name: "Fertilizers", route: "/Fertilizers", type: "link" },
        { name: "Travel & Tourism", route: "/Tourism", type: "link" },
        // { name: "Wishlist", route: "/Wishlist", type: "link" },
        // { name: "Cart", route: "/Cart", type: "link" },
        // { name: "Profile", route: "/Profile", type: "link" },
      ],
    }
  }
}
</script>